<template>
  <div style="margin-top: -36px; ">
    <faq-question
      v-for="(question, index) in questions"
      v-bind:key="index"
      :question="question.question"
      :answer="question.answer" />
  </div>
</template>

<script>

import RareLegalFaqQuestionComponent from './RareLegalFaqQuestionComponent';

export default {
  name: 'RareLegalFAQ',
  components: {
    'faq-question': RareLegalFaqQuestionComponent,
  },
  data() {
    return {
      questions: [
        {
          question: 'Is the service only for ethnic minority candidates?',
          answer: 'No. Our specialist is ethnic minority candidates, but we are open to all.',
        },
        {
          question: 'I require sponsorship to work in the UK – can you help me?',
          answer: 'Possibly. Contact <a href="mailto:puneet.tahim@rarerecruitment.co.uk">Puneet Tahim</a> for more info.',
        },
        {
          question: 'I am not qualified in England and Wales - can you help me?',
          answer: 'Possibly. Contact <a href="mailto:puneet.tahim@rarerecruitment.co.uk">Puneet Tahim</a> for more info.',
        },
        {
          question: 'Will you share my personal data - even anonymously - with anyone?',
          answer: 'No, we absolutely 100% guarantee never to share your data with anyone other than potential employers.' +
          ' We\'ve got the ISO27001 information security classification and we plan on keeping it!',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

</style>



// WEBPACK FOOTER //
// src/pages/legal/components/RareLegalQualifiedLawyersFAQ.vue